"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupNetworkingValidators = void 0;

var MISSING_SERVICE_APP_1 = require("./MISSING_SERVICE_APP");

var MISSING_INGRESS_SERVICE_1 = require("./MISSING_INGRESS_SERVICE");

var MISSING_INGRESS_SERVICE_PORT_1 = require("./MISSING_INGRESS_SERVICE_PORT");

var SERVICE_MULTIPLE_APPS_1 = require("./SERVICE_MULTIPLE_APPS");

var SERVICE_MISSING_PORT_1 = require("./SERVICE_MISSING_PORT");

var INGRESS_NOT_MOUNT_TO_APPS_1 = require("./INGRESS_NOT_MOUNT_TO_APPS");

function setupNetworkingValidators(builder) {
  MISSING_SERVICE_APP_1.setupMISSING_SERVICE_APP(builder);
  MISSING_INGRESS_SERVICE_1.setupMISSING_INGRESS_SERVICE(builder);
  MISSING_INGRESS_SERVICE_PORT_1.setupMISSING_INGRESS_SERVICE_PORT(builder);
  SERVICE_MULTIPLE_APPS_1.setupSERVICE_MULTIPLE_APPS(builder);
  SERVICE_MISSING_PORT_1.setupSERVICE_MISSING_PORT(builder);
  INGRESS_NOT_MOUNT_TO_APPS_1.setupINGRESS_NOT_MOUNT_TO_APPS(builder);
}

exports.setupNetworkingValidators = setupNetworkingValidators;